import { render } from "./MaterialCatogary.vue?vue&type=template&id=cd4c1c00&scoped=true"
import script from "./MaterialCatogary.vue?vue&type=script&lang=js"
export * from "./MaterialCatogary.vue?vue&type=script&lang=js"

import "./MaterialCatogary.vue?vue&type=style&index=0&id=cd4c1c00&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4c1c00"]])

export default __exports__